import axios from "axios";
import { showError, showWarning, sanitizeMessage } from "../../utils/popup";

export const axiosInstance = axios.create({
  // baseURL: `http://localhost/vb_nursing_be/controllers/api/User/`,
  baseURL: `https://nursingupdate.in/testing_be/controllers/api/User/`,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const email = localStorage.getItem("email");

    // Add JWT token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add email to payload automatically
    if (email) {
      if (config.data instanceof FormData) {
        config.data.append("email", email);
      } else {
        config.data = {
          ...(config.data || {}),
          email,
        };
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const tokenErrors = [
  "Authorization header missing.",
  "Invalid Authorization Header.",
  "JWT is empty",
  "header and payload is not set",
  "email payload is empty",
  "token timeout",
  "email id wrong token",
  "Invalid data. Gmail ID is required.",
  "Gmail ID is required"
];

axiosInstance.interceptors.response.use(
  (response) => {
    // Handle raw string responses containing HTML or PHP warnings
    if (typeof response.data === "string") {
      const rawStr = response.data;
      const cleanMsg = sanitizeMessage(rawStr);
      
      const jsonMatch = rawStr.match(/\{[\s\S]*\}/);
      if (jsonMatch) {
        try {
          response.data = JSON.parse(jsonMatch[0]);
        } catch (e) {
          response.data = { message: cleanMsg, error: cleanMsg };
        }
      } else {
        response.data = { message: cleanMsg, error: cleanMsg };
      }
    }

    const msg = response?.data?.message || response?.data?.error;

    if (tokenErrors.includes(msg)) {
      localStorage.clear();
      window.location.href = "/";
    }

    if (response?.data?.error && response?.status === 200) {
      const cleanMsg = sanitizeMessage(response.data.error);
      if (cleanMsg && !response._popupShown) {
        showWarning(cleanMsg);
        response._popupShown = true;
      }
    }

    return response;
  },
  (error) => {
    console.error("API Error:", error);

    let rawErrMsg = error?.response?.data?.message || 
                     error?.response?.data?.error || 
                     error?.response?.data || 
                     error?.message || 
                     "Network error. Please check your internet connection.";

    const cleanMsg = sanitizeMessage(rawErrMsg);

    if (tokenErrors.includes(cleanMsg)) {
      localStorage.clear();
      window.location.href = "/";
    } else if (!error._popupShown) {
      showError(cleanMsg, "Error");
      error._popupShown = true;
    }

    return Promise.reject(error);
  }
);